import { css } from 'styled-components'
import {
  CLONED_CONTENTS_CLASS_NAME,
  DICTIONARY_HIGHLIGHT_CLASS_NAME,
  REGISTERED_WORD_CLASS_NAME,
  SELECTED_WORD_CLASS_NAME,
} from './constants'

export const dictionaryHighlightStyle = css`
  .ql-container.hover p {
    cursor: pointer;
  }

  .${CLONED_CONTENTS_CLASS_NAME}.ql-editor {
    position: absolute;
    visibility: hidden;
    color: transparent;
    pointer-events: none;
  }

  span.${DICTIONARY_HIGHLIGHT_CLASS_NAME} {
    display: inline;
    visibility: visible;
    padding: 4px 0;
    border-radius: 4px;

    &.${REGISTERED_WORD_CLASS_NAME} {
      text-decoration: underline;
      text-decoration-color: #000000;
      text-decoration-thickness: 2px;
      text-underline-offset: 2px;
      pointer-events: auto;
    }

    &.${SELECTED_WORD_CLASS_NAME} {
      background-color: #3075f680;
      box-shadow: inset 0 0px 0 0.5px white;
    }
  }
`
